// 共用常量
// local storage key
export const LOCAL_STORAGE_KEY = 'SXYT'

// api base url
export const BASE_URL = '/coupon/'

// upload file url
export const UPLOAD_URL = BASE_URL + 'upload'

// download file url
export const DOWNLOAD_URL = '/'

// keepAlive Views path
export const KEEP_ALIVE_VIEWS = []
